var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTeamGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_12413)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_442_12413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5391 0.585938H36.3281C35.9766 0.585938 35.6953 0.867187 35.6953 1.21875V5.78906H36.8437C37.7344 5.76562 38.4609 6.46875 38.5078 7.33594C38.5312 8.22656 37.8281 8.95312 36.9609 9C36.9375 9 36.9375 9 36.9141 9H35.6953V13.0781C35.6953 13.4297 35.9766 13.7109 36.3281 13.7109H40.3359V14.9297C40.3125 15.8203 41.0156 16.5469 41.8828 16.5938C42.7734 16.6172 43.5 15.9141 43.5469 15.0469C43.5469 15.0234 43.5469 15.0234 43.5469 15V13.7109H48.1875C48.5391 13.7109 48.8203 13.4297 48.8203 13.0781V3.86719C48.8203 2.0625 47.3438 0.585938 45.5391 0.585938Z",
    fill: "url(#paint0_radial_442_12413)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5391 0.585938H36.3281C35.9766 0.585938 35.6953 0.867187 35.6953 1.21875V5.78906H36.8437C37.7344 5.76562 38.4609 6.46875 38.5078 7.33594C38.5312 8.22656 37.8281 8.95312 36.9609 9C36.9375 9 36.9375 9 36.9141 9H35.6953V13.0781C35.6953 13.4297 35.9766 13.7109 36.3281 13.7109H40.3359V14.9297C40.3125 15.8203 41.0156 16.5469 41.8828 16.5938C42.7734 16.6172 43.5 15.9141 43.5469 15.0469C43.5469 15.0234 43.5469 15.0234 43.5469 15V13.7109H48.1875C48.5391 13.7109 48.8203 13.4297 48.8203 13.0781V3.86719C48.8203 2.0625 47.3438 0.585938 45.5391 0.585938Z",
    stroke: "url(#paint1_linear_442_12413)",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.2187 11.3672H30.0703V6.79688C30.0703 6.44531 29.7891 6.16406 29.4375 6.16406H20.25C18.4219 6.16406 16.9688 7.64062 16.9688 9.44531V19.2656H22.1016V18.0469C22.0781 17.1562 22.7812 16.4297 23.6484 16.3828C24.5391 16.3594 25.2656 17.0625 25.3125 17.9297V17.9766V19.2656H30.0937V14.5781H31.3125C32.2031 14.5781 32.9297 13.8516 32.9297 12.9609C32.9297 12.9375 32.9297 12.9375 32.9297 12.9141C32.8594 12.0234 32.1094 11.3438 31.2187 11.3672Z",
    fill: "url(#paint2_linear_442_12413)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_442_12413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5631 19.2891H37.9224V20.5078C37.9459 21.3984 37.2428 22.125 36.3756 22.1719C35.4849 22.1953 34.7584 21.4922 34.7115 20.625C34.7115 20.6016 34.7115 20.6016 34.7115 20.5781V19.2891H30.0709V24H28.7818C27.8912 23.9766 27.1646 24.6797 27.1178 25.5469C27.0943 26.4375 27.7974 27.1641 28.6646 27.2109H28.7115H30.0709V32.4141H34.3365C34.8287 32.4141 35.274 32.6484 35.5553 33.0703L37.4068 35.8359C37.7115 36.2578 38.3209 36.3516 38.7428 36.0469C39.0006 35.8594 39.1412 35.5781 39.1412 35.2734V33.0469C39.1412 32.7187 39.4224 32.4375 39.7506 32.4375H39.9146C41.7428 32.4375 43.1959 30.9609 43.1959 29.1562V19.9219C43.1959 19.5703 42.9146 19.2891 42.5631 19.2891Z",
    fill: "url(#paint3_radial_442_12413)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5631 19.2891H37.9224V20.5078C37.9459 21.3984 37.2428 22.125 36.3756 22.1719C35.4849 22.1953 34.7584 21.4922 34.7115 20.625C34.7115 20.6016 34.7115 20.6016 34.7115 20.5781V19.2891H30.0709V24H28.7818C27.8912 23.9766 27.1646 24.6797 27.1178 25.5469C27.0943 26.4375 27.7974 27.1641 28.6646 27.2109H28.7115H30.0709V32.4141H34.3365C34.8287 32.4141 35.274 32.6484 35.5553 33.0703L37.4068 35.8359C37.7115 36.2578 38.3209 36.3516 38.7428 36.0469C39.0006 35.8594 39.1412 35.5781 39.1412 35.2734V33.0469C39.1412 32.7187 39.4224 32.4375 39.7506 32.4375H39.9146C41.7428 32.4375 43.1959 30.9609 43.1959 29.1562V19.9219C43.1959 19.5703 42.9146 19.2891 42.5631 19.2891Z",
    stroke: "url(#paint4_linear_442_12413)",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.7812 23.9996H30.0703V19.2887H25.2891V18.0699C25.3125 17.1793 24.6094 16.4527 23.7422 16.4058C22.8516 16.3824 22.125 17.0855 22.0781 17.9527V17.9996V19.2887H16.9453V29.109C16.9453 30.9371 18.4219 32.3902 20.2266 32.3902C20.5547 32.3902 20.8359 32.6715 20.8359 32.9996V35.2262C20.8359 35.7652 21.2578 36.1871 21.7969 36.1871C22.1016 36.1871 22.3828 36.0465 22.5703 35.7887L24.4219 33.023C24.7031 32.6246 25.1484 32.3668 25.6406 32.3668H30.0703V27.1637H28.7109C27.8203 27.1637 27.0937 26.4371 27.0937 25.5465C27.0937 25.523 27.0937 25.523 27.0937 25.4996C27.1641 24.6793 27.9141 23.9762 28.7812 23.9996Z",
    fill: "url(#paint5_linear_442_12413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 31.9219C9.58594 31.7812 9 31.2188 8.85938 30.4922C8.85938 30.4688 8.78906 30.4688 8.78906 30.4922C8.64844 31.2188 8.0625 31.7812 7.33594 31.9219C7.3125 31.9219 7.3125 31.9687 7.33594 31.9922C8.0625 32.1328 8.64844 32.6953 8.78906 33.4219C8.78906 33.4453 8.85938 33.4453 8.85938 33.4219C9 32.6953 9.58594 32.1328 10.3125 31.9922C10.3359 31.9687 10.3359 31.9219 10.3125 31.9219Z",
    fill: "url(#paint6_radial_442_12413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.632 22.2891H54.0695V21.75C54.0695 21.3516 53.7414 21 53.343 21H53.3195C52.9211 21 52.593 21.3281 52.5695 21.7266V22.2891H52.0305C51.632 22.2891 51.2805 22.6172 51.2805 23.0156V23.0391C51.257 23.4375 51.5852 23.7656 51.9836 23.7891H52.0305H52.5695V24.3281C52.5695 24.7266 52.8977 25.0781 53.2961 25.0781H53.3195C53.718 25.0781 54.0461 24.75 54.0695 24.3516V23.7891H54.6086C55.007 23.7891 55.3586 23.4609 55.3586 23.0625V23.0391C55.3586 22.6406 55.0305 22.3125 54.632 22.2891Z",
    fill: "url(#paint7_radial_442_12413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8437 34.0547C49.2839 34.0547 49.6406 33.6979 49.6406 33.2578C49.6406 32.8177 49.2839 32.4609 48.8437 32.4609C48.4036 32.4609 48.0469 32.8177 48.0469 33.2578C48.0469 33.6979 48.4036 34.0547 48.8437 34.0547Z",
    fill: "url(#paint8_radial_442_12413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9063 1.59375C18.3464 1.59375 18.7031 1.23698 18.7031 0.796875C18.7031 0.356773 18.3464 0 17.9063 0C17.4661 0 17.1094 0.356773 17.1094 0.796875C17.1094 1.23698 17.4661 1.59375 17.9063 1.59375Z",
    fill: "url(#paint9_radial_442_12413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0156 7.54688C9.96094 7.35938 9.14062 6.53906 8.92969 5.50781C8.92969 5.46094 8.83594 5.46094 8.83594 5.50781C8.625 6.53906 7.80469 7.35938 6.75 7.54688C6.70313 7.54688 6.70313 7.61719 6.75 7.64062C7.80469 7.82812 8.625 8.64844 8.83594 9.67969C8.83594 9.72656 8.92969 9.72656 8.92969 9.67969C9.14062 8.64844 9.96094 7.82812 11.0156 7.64062C11.0625 7.61719 11.0625 7.54688 11.0156 7.54688Z",
    fill: "url(#paint10_radial_442_12413)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_442_12413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 47.5547C32.3041 47.5547 34.1719 45.6869 34.1719 43.3828C34.1719 41.0788 32.3041 39.2109 30 39.2109C27.6959 39.2109 25.8281 41.0788 25.8281 43.3828C25.8281 45.6869 27.6959 47.5547 30 47.5547Z",
    fill: "url(#paint11_radial_442_12413)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 47.5547C32.3041 47.5547 34.1719 45.6869 34.1719 43.3828C34.1719 41.0788 32.3041 39.2109 30 39.2109C27.6959 39.2109 25.8281 41.0788 25.8281 43.3828C25.8281 45.6869 27.6959 47.5547 30 47.5547Z",
    stroke: "url(#paint12_linear_442_12413)",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_442_12413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3672 48.2109H27.6562C24.7969 48.2109 22.4766 50.5313 22.4766 53.3906V58.0781C22.4766 58.8047 23.0625 59.3906 23.7891 59.3906H36.2344C36.9609 59.3906 37.5469 58.8047 37.5469 58.0781V53.3906C37.5234 50.5313 35.2266 48.2344 32.3672 48.2109Z",
    fill: "url(#paint13_radial_442_12413)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3672 48.2109H27.6562C24.7969 48.2109 22.4766 50.5313 22.4766 53.3906V58.0781C22.4766 58.8047 23.0625 59.3906 23.7891 59.3906H36.2344C36.9609 59.3906 37.5469 58.8047 37.5469 58.0781V53.3906C37.5234 50.5313 35.2266 48.2344 32.3672 48.2109Z",
    stroke: "url(#paint14_linear_442_12413)",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_442_12413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 47.5547C14.4916 47.5547 16.3594 45.6869 16.3594 43.3828C16.3594 41.0788 14.4916 39.2109 12.1875 39.2109C9.88344 39.2109 8.01562 41.0788 8.01562 43.3828C8.01562 45.6869 9.88344 47.5547 12.1875 47.5547Z",
    fill: "url(#paint15_radial_442_12413)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 47.5547C14.4916 47.5547 16.3594 45.6869 16.3594 43.3828C16.3594 41.0788 14.4916 39.2109 12.1875 39.2109C9.88344 39.2109 8.01562 41.0788 8.01562 43.3828C8.01562 45.6869 9.88344 47.5547 12.1875 47.5547Z",
    stroke: "url(#paint16_linear_442_12413)",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_442_12413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5547 48.2109H9.82031C6.96094 48.2109 4.64062 50.5313 4.64062 53.3906V58.0781C4.64062 58.8047 5.22656 59.3906 5.95313 59.3906H18.3984C19.125 59.3906 19.7109 58.8047 19.7109 58.0781V53.3906C19.7344 50.5313 17.4141 48.2344 14.5547 48.2109Z",
    fill: "url(#paint17_radial_442_12413)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5547 48.2109H9.82031C6.96094 48.2109 4.64062 50.5313 4.64062 53.3906V58.0781C4.64062 58.8047 5.22656 59.3906 5.95313 59.3906H18.3984C19.125 59.3906 19.7109 58.8047 19.7109 58.0781V53.3906C19.7344 50.5313 17.4141 48.2344 14.5547 48.2109Z",
    stroke: "url(#paint18_linear_442_12413)",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.8125 47.5547C50.1166 47.5547 51.9844 45.6869 51.9844 43.3828C51.9844 41.0788 50.1166 39.2109 47.8125 39.2109C45.5084 39.2109 43.6406 41.0788 43.6406 43.3828C43.6406 45.6869 45.5084 47.5547 47.8125 47.5547Z",
    fill: "url(#paint19_linear_442_12413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1797 48.2109H45.4688C42.6094 48.2109 40.2891 50.5313 40.2891 53.3906V58.0781C40.2891 58.8047 40.875 59.3906 41.6016 59.3906H54.0469C54.7734 59.3906 55.3594 58.8047 55.3594 58.0781V53.3906C55.3359 50.5313 53.0391 48.2344 50.1797 48.2109Z",
    fill: "url(#paint20_linear_442_12413)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_442_12413",
    x: 11.1953,
    y: -23.9141,
    width: 62.125,
    height: 65.0088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_442_12413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_442_12413",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_442_12413",
    x: 2.61719,
    y: -5.21094,
    width: 65.0781,
    height: 65.9365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_442_12413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_442_12413",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_442_12413",
    x: 1.32812,
    y: 14.7109,
    width: 57.3438,
    height: 57.3438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_442_12413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_442_12413",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_442_12413",
    x: -2.02344,
    y: 23.7109,
    width: 64.0703,
    height: 60.1797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_442_12413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_442_12413",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_442_12413",
    x: -16.4844,
    y: 14.7109,
    width: 57.3438,
    height: 57.3438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_442_12413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_442_12413",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_442_12413",
    x: -19.8594,
    y: 23.7109,
    width: 64.0703,
    height: 60.1797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_442_12413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_442_12413",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6953 0.585938) rotate(50.6523) scale(20.7011 20.2994)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282835"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_442_12413",
    x1: 42.2578,
    y1: 0.585937,
    x2: 42.2578,
    y2: 16.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1ACFF",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_442_12413",
    x1: 24.9492,
    y1: 6.40661,
    x2: 24.9492,
    y2: 16.7246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E592BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA589B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.1172 19.2891) rotate(46.4887) scale(23.3533 23.3218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282835"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_442_12413",
    x1: 35.1565,
    y1: 19.2891,
    x2: 35.1565,
    y2: 36.2258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1ACFF",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_442_12413",
    x1: 23.5078,
    y1: 16.7715,
    x2: 23.5078,
    y2: 32.3504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E592BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA589B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.31647 31.3513) scale(2.25596 2.22085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6312 22.2059) scale(3.05564 3.05476)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5751 32.9322) scale(1.19381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6376 0.471268) scale(1.19381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.15182 6.72706) scale(3.24788 3.17765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8281 39.2109) rotate(45) scale(11.7998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282835"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_442_12413",
    x1: 30,
    y1: 39.2109,
    x2: 30,
    y2: 47.5547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1ACFF",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4766 48.2109) rotate(36.5693) scale(18.7643 17.9576)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282835"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_442_12413",
    x1: 30.0117,
    y1: 48.2109,
    x2: 30.0117,
    y2: 59.3906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1ACFF",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.01562 39.2109) rotate(45) scale(11.7998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282835"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_442_12413",
    x1: 12.1875,
    y1: 39.2109,
    x2: 12.1875,
    y2: 47.5547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1ACFF",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_442_12413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.64062 48.2109) rotate(36.569) scale(18.7645 17.9577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282835"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_442_12413",
    x1: 12.1759,
    y1: 48.2109,
    x2: 12.1759,
    y2: 59.3906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1ACFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1ACFF",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_442_12413",
    x1: 47.8125,
    y1: 39.3654,
    x2: 47.8125,
    y2: 45.9364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E592BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA589B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_442_12413",
    x1: 47.8242,
    y1: 48.4179,
    x2: 47.8242,
    y2: 57.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E592BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA589B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_12413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTeamGraphic);
export default __webpack_public_path__ + "static/media/newTeamGraphic.2f434b49e11fc088c0545ac6ebeea4b4.svg";
export { ForwardRef as ReactComponent };